import { useEffect, useState } from 'react';
import { PostpartumCourse } from './PostpartumCourse';
import { TransportEntry } from './TransportEntry';
import { TransportTimeline } from './TransportTimeline';
import { withNewbornSubjects } from './newbornSubjects';
import { encounterAllowsSubject, type ScopedEncounter } from './courseEncounterScope';
import type { BirthWorkspaceProps } from './LaborFlowsheet';
export interface Phase3WorkspaceProps extends BirthWorkspaceProps {
  encounters: (ScopedEncounter & { encounter_date: string; encounter_type?: string | null })[];
}
export function Phase3Workspace(props: Phase3WorkspaceProps) {
  const [augmented, setAugmented] = useState(props.episode);
  useEffect(() => {
    let current = true;
    void withNewbornSubjects(props.episode).then((e) => {
      if (current) setAugmented(e);
    });
    return () => {
      current = false;
    };
  }, [props.episode]);
  const allowed = augmented.subjects
    .filter(
      (s) =>
        s.active !== false &&
        encounterAllowsSubject(
          props.encounters.find((e) => e.id === props.encounterId),
          augmented,
          s.id,
        ),
    )
    .map((s) => s.id);
  const config = props.configuration?.postpartum_course;
  return (
    <div className="flex flex-col gap-5" data-encounter-draft>
      <PostpartumCourse
        {...props}
        episode={augmented}
        allowedSubjectIds={allowed}
        reviewedEpdsThreshold={
          props.configuration?.clinically_reviewed && config?.clinically_reviewed && config.enabled
            ? config.epds_total_threshold
            : undefined
        }
        encounters={props.encounters.map((e) => ({
          id: e.id,
          date: e.encounter_date,
          label: e.encounter_type ?? 'Visit',
          kind: e.encounter_type ?? undefined,
        }))}
      />
      <TransportEntry
        {...props}
        episode={{ ...augmented, subjects: augmented.subjects.filter((s) => allowed.includes(s.id)) }}
      />
      <TransportTimeline
        episodeId={props.episode.id}
        events={props.events}
        subjects={augmented.subjects}
        timeZone={props.timeZone}
        onEdit={props.onEdit}
      />
    </div>
  );
}
